
var m = require('mithril');
var prop = require('mithril/stream')

module.exports = {
  oninit: function(vnode) {
    var ctrl = this;
    ctrl.equipmentRecord = vnode.attrs.equipmentRecord;
    ctrl.parentRecord = vnode.attrs.parentRecord;
    ctrl.groupByLocation = vnode.attrs.groupByLocation;
    ctrl.recordType = vnode.attrs.recordType;
  },

  onupdate: function(vnode) {
    var ctrl = this;
    if (ctrl.equipmentRecord['@rid'] != vnode.attrs.equipmentRecord['@rid'] || ctrl.equipmentRecord['$path'].length != vnode.attrs.equipmentRecord['$path'].length) {
      ctrl.equipmentRecord = vnode.attrs.equipmentRecord;
      ctrl.parentRecord = vnode.attrs.parentRecord;
      ctrl.groupByLocation = vnode.attrs.groupByLocation;
      ctrl.recordType = vnode.attrs.recordType;
      m.redraw();
    }
    if (ctrl.groupByLocation != vnode.attrs.groupByLocation) {
      ctrl.groupByLocation = vnode.attrs.groupByLocation;
      ctrl.recordType = vnode.attrs.recordType;
      m.redraw();
    }
  },
  view: function(vnode) {
    var ctrl = this; 
    var formatLocationLabel = function (record) {
      if (!record) return '';
      if (record.name === 'root') return 'Home';
      var baseName = record.name || record['@class'] || '';
      if (record.roomNumber) return `${baseName} ${record.roomNumber}`;
      return baseName;
    };
    var parentRecord = typeof ctrl.parentRecord === 'function' ? ctrl.parentRecord() : ctrl.parentRecord;
    var renderTruncatedPath = function () {
      var pathRecord = (ctrl.equipmentRecord.$path || []).find(function (path) {
        return path &&
          path['@class'] == ctrl.equipmentRecord['@class'] &&
          path['@rid'] == ctrl.equipmentRecord['@rid'];
      }) || ctrl.equipmentRecord;
      var label = ctrl.recordType === 'location'
        ? formatLocationLabel(pathRecord)
        : (pathRecord.name || pathRecord['@class']);
      var href = ctrl.recordType === 'location'
        ? '/location/' + ctrl.equipmentRecord['@rid'].slice(1)
        : '/equipment/' + ctrl.equipmentRecord['@class'].toLowerCase() + '/' + ctrl.equipmentRecord['@rid'].slice(1);
      return m('span.smart-table-truncated-path', [
        m(m.route.Link, { class: 'smart-table-path-last', href: href }, label)
      ]);
    };
    if (vnode.attrs.truncateStart) {
      return renderTruncatedPath();
    }
    if (ctrl.groupByLocation) {
      return ctrl.equipmentRecord.$path.map(function(path, idx) {
        var isParentRecord = parentRecord &&
          path['@class'] == parentRecord['@class'] &&
          path['@rid'] == parentRecord['@rid'];
        var isEquipmentRecord = path['@class'] == ctrl.equipmentRecord['@class'] && path['@rid'] == ctrl.equipmentRecord['@rid'];
        if (isParentRecord && !isEquipmentRecord) {
          return ''
        } if (isEquipmentRecord) {
          if (ctrl.recordType === 'location') {
            return m(m.route.Link, { href: '/location/' + ctrl.equipmentRecord['@rid'].slice(1), }, formatLocationLabel(path));
          }
          return m(m.route.Link, { href: '/equipment/' + ctrl.equipmentRecord['@class'].toLowerCase() + '/' + ctrl.equipmentRecord['@rid'].slice(1), }, path.name || path['@class'])
        } else if (
          ctrl.recordType !== 'location' &&
          path['@class'] != 'Site' &&
          path['@class'] != 'Building' &&
          path['@class'] != 'Level' &&
          path['@class'] != 'Room'
        ) {
          return m('div.mr1', [
            m(m.route.Link, { class: 'mr1', href: `/equipment/${path['@class'].toLowerCase()}/${path['@rid'].slice(1)}`}, path.name),
            '/'
          ])
        } else {
          return m('div.mr1', [
            m(m.route.Link, { 
              class: 'mr1', 
              href: `/location/${path['@rid'].slice(1)}${m.route.get().split('?')[1] ? `?${m.route.get().split('?')[1]}`:''}`
            }, 
            formatLocationLabel(path)),
            '/'
          ])
          
        }
      })
    } else {  
      return ctrl.equipmentRecord.$path.map(function(path, idx) {
        if (path['@class'] == ctrl.equipmentRecord['@class'] && path['@rid'] == ctrl.equipmentRecord['@rid']) {
          if (ctrl.recordType === 'location') {
            return m(m.route.Link, { href: '/location/' + ctrl.equipmentRecord['@rid'].slice(1), }, formatLocationLabel(path));
          }
          return m(m.route.Link, { href: '/equipment/' + ctrl.equipmentRecord['@class'].toLowerCase() + '/' + ctrl.equipmentRecord['@rid'].slice(1), }, path.name || path['@class'])
        } else if (parentRecord && path['@class'] == parentRecord['@class']) {
          return m('div')
        } else if (
          ctrl.recordType !== 'location' &&
          path['@class'] != 'Site' &&
          path['@class'] != 'Building' &&
          path['@class'] != 'Level' &&
          path['@class'] != 'Room'
        ) {
          return m('div.mr1', [
            m(m.route.Link, { class: 'mr1', href: `/equipment/${path['@class'].toLowerCase()}/${path['@rid'].slice(1)}`}, path.name  || path['@class']),
            '/'
          ])
        }
        else {
          return m('div.mr1', [
            m(m.route.Link, { 
              class: 'mr1', 
              href: `/location/${path['@rid'].slice(1)}${m.route.get().split('?')[1] ? `?${m.route.get().split('?')[1]}`:''}`
            }, 
            formatLocationLabel(path)),
            '/'
          ])
          
        }
      })
    }
  }
};
